/**
 * Freedom Tabs Collection JavaScript
 * Handles tab switching with per-tab images and product carousels
 */

(function() {
  'use strict';

  // Update scrollbar indicator
  function updateScrollbar(carouselTrack) {
    if (!carouselTrack) return;
    
    const carousel = carouselTrack.closest('.freedom-tabs-collection__carousel');
    if (!carousel) return;
    
    const scrollbar = carousel.querySelector('.freedom-tabs-collection__carousel-scrollbar');
    const drag = scrollbar ? scrollbar.querySelector('.freedom-tabs-collection__carousel-scrollbar-drag') : null;
    
    if (!scrollbar || !drag) return;
    
    const scrollWidth = carouselTrack.scrollWidth;
    const clientWidth = carouselTrack.clientWidth;
    const scrollLeft = carouselTrack.scrollLeft;
    const maxScroll = scrollWidth - clientWidth;
    
    if (maxScroll <= 0) {
      drag.style.width = '100%';
      drag.style.left = '0';
      return;
    }
    
    const scrollbarWidth = scrollbar.offsetWidth;
    const dragWidth = (clientWidth / scrollWidth) * scrollbarWidth;
    const dragLeft = (scrollLeft / maxScroll) * (scrollbarWidth - dragWidth);
    
    drag.style.width = Math.max(dragWidth, 20) + 'px';
    drag.style.left = dragLeft + 'px';
  }

  // Initialize scrollbar for a carousel track
  function initScrollbarForTrack(track) {
    if (!track) return;
    
    // Check if already initialized
    if (track._scrollbarInitialized) {
      updateScrollbar(track);
      return;
    }
    
    // Mark as initialized
    track._scrollbarInitialized = true;
    
    // Update scrollbar immediately
    updateScrollbar(track);
    
    // Attach scroll listener
    track.addEventListener('scroll', function() {
      updateScrollbar(track);
    }, { passive: true });
    
    // Update on resize (debounced)
    let resizeTimer;
    const resizeHandler = function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        updateScrollbar(track);
      }, 100);
    };
    window.addEventListener('resize', resizeHandler);
    
    // Also update after images load
    const images = track.querySelectorAll('img');
    let imagesLoaded = 0;
    const totalImages = images.length;
    
    if (totalImages > 0) {
      images.forEach(function(img) {
        if (img.complete) {
          imagesLoaded++;
        } else {
          img.addEventListener('load', function() {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              setTimeout(function() {
                updateScrollbar(track);
              }, 50);
            }
          });
          img.addEventListener('error', function() {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              setTimeout(function() {
                updateScrollbar(track);
              }, 50);
            }
          });
        }
      });
      
      if (imagesLoaded === totalImages) {
        setTimeout(function() {
          updateScrollbar(track);
        }, 50);
      }
    }
  }

  // Switch to a tab
  function switchTab(tabIndex, ctaLink) {
    const section = document.querySelector('.freedom-tabs-collection[data-section-id]');
    if (!section) return;

    // Hide all tab content (product carousels)
    const allTabContent = section.querySelectorAll('[data-tab-content]');
    allTabContent.forEach(function(content) {
      content.classList.add('freedom-tabs-collection__carousel--hidden');
    });

    // Show active tab content
    const activeTabContent = section.querySelector('[data-tab-content="' + tabIndex + '"]');
    if (activeTabContent) {
      activeTabContent.classList.remove('freedom-tabs-collection__carousel--hidden');
      // Initialize scrollbar for active tab
      const carouselTrack = activeTabContent.querySelector('[data-carousel-track]');
      if (carouselTrack) {
        setTimeout(function() {
          initScrollbarForTrack(carouselTrack);
        }, 100);
      }
    }

    // Hide all tab images
    const allTabImages = section.querySelectorAll('[data-tab-image]');
    allTabImages.forEach(function(imageWrapper) {
      imageWrapper.classList.add('freedom-tabs-collection__image-wrapper--hidden');
    });

    // Show active tab image
    const activeTabImage = section.querySelector('[data-tab-image="' + tabIndex + '"]');
    if (activeTabImage) {
      activeTabImage.classList.remove('freedom-tabs-collection__image-wrapper--hidden');
    }

    // Update CTA link
    const ctaButton = section.querySelector('[data-cta-link]');
    if (ctaButton && ctaLink) {
      ctaButton.href = ctaLink;
    }
  }

  // Initialize tabs
  function initTabs() {
    const section = document.querySelector('.freedom-tabs-collection[data-section-id]');
    if (!section) return;

    const tabs = section.querySelectorAll('.freedom-tabs-collection__tab');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const tabIndex = parseInt(this.getAttribute('data-tab-index'), 10);
        const ctaLink = this.getAttribute('data-collection-url');

        // Update active tab
        tabs.forEach(function(t) {
          t.classList.remove('freedom-tabs-collection__tab--active');
        });
        this.classList.add('freedom-tabs-collection__tab--active');

        // Switch to this tab's content and image
        switchTab(tabIndex, ctaLink);
      });
    });

    // Initialize scrollbar indicators for visible carousels only
    const visibleCarousels = section.querySelectorAll('.freedom-tabs-collection__carousel:not(.freedom-tabs-collection__carousel--hidden)');
    visibleCarousels.forEach(function(carousel) {
      const track = carousel.querySelector('[data-carousel-track]');
      if (track) {
        initScrollbarForTrack(track);
      }
    });

  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }

  // Re-initialize when section reloads (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section && section.classList.contains('freedom-tabs-collection')) {
      initTabs();
    }
  });
})();
